import { render } from "./ThresholdInfoPopup.vue?vue&type=template&id=105c56d2&scoped=true"
import script from "./ThresholdInfoPopup.js?vue&type=script&lang=js"
export * from "./ThresholdInfoPopup.js?vue&type=script&lang=js"

import "./ThresholdInfoPopup.vue?vue&type=style&index=0&id=105c56d2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105c56d2"]])

export default __exports__